import { ApiDefinitionArticleDto, ApiDefinitionDto } from '../../types/api';
import { formatAxiosError } from './common/api-error-handler';
import { axiosClient } from './common';
import { ApiDefinition } from '@/types/api-definitions';
import { mapApiDefinitions, mapApiDefinition } from '@/mappers';

export async function getApiDefinitions(): Promise<ApiDefinition[]> {
  try {
    const response = await axiosClient.get<ApiDefinitionDto[]>('/v1/ApiDefinitions');

    const result = mapApiDefinitions(response.data);
    return result;
  } catch (error) {
    const formattedError = formatAxiosError(error as any, 'Get API definitions');
    console.error('API call failed:', formattedError.message);
    throw formattedError;
  }
}

export async function getApiDefinitionBySlug(slug: string): Promise<ApiDefinition> {
  try {
    const response = await axiosClient.get<ApiDefinitionDto>(`/v1/ApiDefinitions/${slug}`);
    const result = mapApiDefinition(response.data);
    return result;
  } catch (error) {
    const formattedError = formatAxiosError(error as any, 'Get API definition by slug');
    console.error('API call failed:', formattedError.message);
    throw formattedError;
  }
}

export async function getApiDefinitionOpenApiSpec(slug: string): Promise<any> {
  try {
    const response = await axiosClient.get(`/v1/ApiDefinitions/${slug}/openapi`);

    if (response.data.openApiDefinitionContentJson) {
      return JSON.parse(response.data.openApiDefinitionContentJson);
    }
    return response.data;
  } catch (error) {
    const formattedError = formatAxiosError(error as any, 'Get API definition OpenAPI spec');
    console.error('API call failed:', formattedError.message);
    throw formattedError;
  }
}

export async function getApiDefinitionArticles(slug: string): Promise<ApiDefinitionArticleDto[]> {
  try {
    const response = await axiosClient.get(`/v1/ApiDefinitions/${slug}/documentationArticles`);
    const result = response.data.articles as ApiDefinitionArticleDto[];
    return result;
  } catch (error) {
    const formattedError = formatAxiosError(error as any, 'Get API definition articles');
    console.error('API call failed:', formattedError.message);
    throw formattedError;
  }
}
